'use client';
import { routes } from '@/lib';
import { useGetUserQuery } from '@scaleup/frontend/api';
import { OrgTypes } from '@scaleup/models';
import { useRouter } from 'next/navigation';

export const Redirect = () => {
  const router = useRouter();
  const { data: user } = useGetUserQuery();

  if (!user) {
    return null;
  }

  if (user.org?.orgType === OrgTypes.champion) {
    router.push(routes.champion.dashboard);
    return <></>;
  }

  if(user.admin) {
    router.push(routes.admin.dashboard);
    return <></>;
  }
  
  router.push(routes.supplier.dashboard);

  return <></>;
};
